document.addEventListener('DOMContentLoaded', () => {
    const title = document.querySelector('.author-hero__title');
    if (!title) return;

    const firstName = title.textContent.trim().split(/\s+/)[0];

    document.querySelectorAll('.social-share-buttons__link').forEach(link => {
        const href = link.getAttribute('href') || '';

        if (href.includes('contact-form')) {
            link.addEventListener('click', function () {
                const url = new URL(this.href, window.location.origin);

                url.searchParams.set('to', firstName);

                this.href = url.toString();
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const params = new URLSearchParams(window.location.search);
    const to = params.get('to');

    if (!to) return;

    const interval = setInterval(() => {
        const textarea = document.getElementById('your-message');

        if (!textarea) return;

        clearInterval(interval);

        textarea.value = `To: ${to}\n`;

        textarea.dispatchEvent(new Event('input', { bubbles: true }));
        textarea.dispatchEvent(new Event('change', { bubbles: true }));

        textarea.focus();

        textarea.setSelectionRange(
            textarea.value.length,
            textarea.value.length
        );
    }, 100);
});